<template>
  <div class="topbar" id="topbar">
    <div class="content container-fluid">
      <!--brand-->
      <div class="brand">
        <router-link to="/">
          <img src="../../assets/imgs/logo.png" class="logo" alt="logo komachi">
        </router-link>
      </div>
      <!--navigation-->
      <div class="navigation">
        <ul>
          <li>
            <router-link to="/">Accueil</router-link>
          </li>
          <li v-for="item in menu" :key="item.id">
            <router-link :to="'/' + item.slug  ">{{ item.name }}</router-link>
          </li>
          <li class="search">
            <router-link to="/search">
              <svg width="100%" height="100%" viewBox="0 0 469 484" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><path d="M325.55,315.35c30.883,-33.433 50.15,-78.2 50.15,-127.5c0,-103.417 -84.15,-187.85 -187.85,-187.85c-103.7,0 -187.85,84.433 -187.85,187.85c0,103.417 84.15,187.85 187.85,187.85c42.217,0 81.033,-13.883 112.483,-37.4l139.683,139.683c3.4,3.4 7.65,5.1 11.9,5.1c4.25,0 8.783,-1.7 11.9,-5.1c6.517,-6.517 6.517,-17.283 0,-24.083l-138.266,-138.55Zm-291.55,-127.5c0,-84.717 68.85,-153.85 153.85,-153.85c84.717,0 153.85,68.85 153.85,153.85c0,85 -68.85,153.85 -153.85,153.85c-85,0 -153.85,-69.133 -153.85,-153.85Z" style="fill-rule:nonzero;"/></svg>
            </router-link>
          </li>
          <li class="book-food z-depth-2">
            <router-link to="/reservation">Réserver une table</router-link>
          </li>
        </ul>
      </div>
      <!--menu-mobile-icone-->
      <div @click="toggleMenu()" class="mobile-icon">
        <svg width="100%" height="100%" viewBox="0 0 612 417" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><path id="Rectangle_1_copy_2" d="M0,0l0,24.48l612,0l0,-24.48l-612,0Zm0,220.32l612,0l0,-24.48l-612,0l0,24.48Zm0,195.84l612,0l0,-24.48l-612,0l0,24.48Z" style="fill-rule:nonzero;"/></svg>
      </div>
    </div>
    <!--menu-mobile-->
    <div class="menu-mobile">
       <ul class="navigation mt-3">
          <li @click="toggleMenu()">
            <router-link  to="/">Accueil</router-link>
          </li>
          <li @click="toggleMenu()" v-for="item in menu" :key="item.id">
            <router-link :to="'/' + item.slug">{{ item.name }}</router-link>
          </li>
          <li @click="toggleMenu()">
            <router-link  to="/search">Rechercher</router-link>
          </li>
          <li  @click="toggleMenu()" class="book-food">
            <router-link to="/reservation">Réserver une table</router-link>
          </li>
        </ul>
    </div>
  </div>
</template>
<script>
import api from '@/api'
export default {
  data () {
    return {
      menu: [],
      scrolled: false
    }
  },
  methods: {
    /**
     * Toggle menu
     * Add / remove is-active class
     * When button triggered
     */
    toggleMenu () {
      // eslint-disable-next-line
      let topbar = document.querySelector('.topbar')
      topbar.classList.toggle('is-active')
      this.scrollFix()
    },
    scrollFix: function () {
      window.location = '#title'
    },
    /**
     * Fetch navigation links
     * @request HTTP | GET
     */
    fetchNavigation () {
      this.axios.get(api.navigation)
        .then(response => {
          this.menu = response.data.data
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted () {
    this.fetchNavigation()
  }
}
</script>
<style lang="scss" scoped>
  @import 'Topbar';
</style>



// WEBPACK FOOTER //
// src/components/Topbar/Topbar.vue